import merge from 'lodash/merge'

export const ENV = process.env.NEXT_PUBLIC_ENV

export const STAGING_APP_URL = 'https://auth-staging.neat.com'

export const IS_PROD = ENV === 'production'

const config = {
  default: {
    app: {
      url: 'http://localhost:3003',
    },
    api: {
      cloud: 'https://cloud-staging.neat.com',
      interrogator: 'https://interrogator-staging.neat.com/graphql',
      // interrogator: 'http://localhost:4000/graphql', @TODO maybe add an interrogator api arg? to dev script?
      gatekeeper: 'https://gatekeeper-staging.neat.com',
    },
    clients: {
      google: '79655950420-6gn638tkjk5p35v9e38qut2go3in5ddf.apps.googleusercontent.com',
      jawn: 'http://localhost:3003',
      scrooge: 'https://myaccount-staging.neat.com',
    },
    recaptcha: {
      siteKey: '6Le4CYsqAAAAAIH4semwq0fjDXc3HADgxZSFj6BM',
    },
  },

  development: {},

  test: {},

  staging: {
    app: {
      url: STAGING_APP_URL,
    },
    clients: {
      jawn: 'https://app-staging.neat.com',
    },
  },

  qa: {
    app: {
      url: 'https://auth-qa.neat.com',
    },
    api: {
      cloud: 'https://cloud-qa.neat.com',
      interrogator: 'https://interrogator-qa.neat.com/graphql',
      gatekeeper: 'https://gatekeeper-qa.neat.com',
    },
    clients: {
      google: '289196470141-kvabd0s2th2omc15e2udrjcs0gb0m813.apps.googleusercontent.com',
      jawn: 'https://app-qa.neat.com',
      scrooge: 'https://myaccount-qa.neat.com',
    },
    recaptcha: {
      siteKey: '6LcUHoYqAAAAAATzvYQFN166mC9JpH2a4I1rZ9nJ',
    },

  },

  production: {
    app: {
      url: 'https://auth.neat.com',
    },
    api: {
      cloud: 'https://cloud.neat.com',
      interrogator: 'https://interrogator.neat.com/graphql',
      gatekeeper: 'https://gatekeeper.neat.com',
    },
    clients: {
      google: '661316390459-e1eg9m2vqu9c9m1u11s1tritd71l9v71.apps.googleusercontent.com',
      jawn: 'https://app.neat.com',
      scrooge: 'https://myaccount.neat.com',
    },
    recaptcha: {
      siteKey: '6LfhyIsqAAAAACFimGiXrtFkjYGfyHs9Y_TpNDNx',
    },
  },
}

export default merge(
  {},
  config.default,
  config[ENV],
)
